import { types, Instance, destroy, getRoot } from 'mobx-state-tree';
import { Crop, ICrop, ICropSnapshotIn } from './Crop';
import { callAgroApi } from '@services/agroapi';
import { CropResponse } from '@services/responseTypes';
import { Transformers } from '@services/transformer';
import { IRootStoreAny } from './rootUtilType';
export const CropStore = types.model('CropStore', {
  crops: types.array(types.late(() => Crop))
}).views(self => ({
  get root() {
    return getRoot<IRootStoreAny>(self);
  },
  get cropNameList() {
    const arrayUnique = [...new Map(self.crops.map(crop => [crop.name, {
      label: crop.name,
      value: crop.name
    }])).values()];
    return [{
      label: 'All',
      value: undefined
    }, ...arrayUnique];
  },
  get unspecifiedCrop() {
    const crop = self.crops.find(c => c.canonical_name === 'unspecified');
    return crop;
  },
  get cropCache() {
    return self.crops.reduce((acc, n) => {
      acc[n.id] = true;
      return acc;
    }, {});
  }
})).actions(self => ({
  pushToCrops(crop: ICrop | ICropSnapshotIn) {
    if (!self.cropCache[crop.id]) {
      self.crops.push(crop);
    }
    return crop;
  },
  pushCrops(crops: ICrop[]) {
    const filtered = crops.filter(c => !self.cropCache[c.id]).concat(self.crops);
    self.crops.replace(filtered);
    return crops;
  },
  removeFromCrops(crop: ICrop) {
    destroy(crop);
  },
  filterCropFromGeoJSON(cropName: string) {
    return self.crops.find(c => c.name === cropName) || self.crops.find(c => c.canonical_name === cropName);
  },
  clear() {
    self.crops.clear();
  }
})).actions(self => ({
  fetchCrops(organizationId: string, query?: string, page = 1) {
    return callAgroApi<CropResponse[]>(`/organizations/${organizationId}/crops?page=${page.toString()}${query ? `&filter[query]=${query}&filter[lang]=${self.root.userStore.user.settings.lang}` : ''}`, 'GET').then(({
      data
    }) => self.pushCrops(data.map(crop => Crop.create(Transformers.crop(crop)))));
  },
  fetchRecentCrops(orgId: string) {
    return callAgroApi<CropResponse[]>(`/organizations/${orgId}/recent_crops`, 'GET').then(({
      data
    }) => self.pushCrops(data.map(crop => Crop.create(Transformers.crop(crop)))));
  }
}));
export type ICropStore = Instance<typeof CropStore>;
export const cropStore = CropStore.create({
  crops: []
});